<template>
<v-toolbar id="core-toolbar" flat style="background: #eee; margin:0;">
    <div class="v-toolbar-title hidden-md-and-up">
        <v-toolbar-title class="tertiary--text font-weight-light">
            <v-btn v-if="responsive" class="default v-btn--simple" icon @click.stop="onClickBtn">
                <v-icon color="green">mdi-view-list</v-icon>
            </v-btn>
            <strong style="font-size:18px;">{{ title }}</strong>
        </v-toolbar-title>
    </div>

    <v-tabs v-if="$route.path == '/dashboard' || $route.path == '/'"
     v-model="tabs" @change="changeTabs($event)" color="transparent" slider-color="accent">
        <v-tab v-for="(tab,index) in textTabs" :key="index">
            {{ tab }}
        </v-tab>
    </v-tabs> 

    <v-spacer />

</v-toolbar>
</template>

<script>


import store from '@/store';

import {
    mapMutations
} from "vuex";

export default {
    data: () => ({
        notifications: [
            "Mike, John responded to your email",
            "You have 5 new tasks",
            "You're now a friend with Andrew",
            "Another Notification",
            "Another One"
        ],
        title: null,
        responsive: false,
        creditors: {},
        tabs: null,
        textTabs: ['Disparos', 'Clientes'],
        text: "lsdfasidfuyhasduifuyahsduifuyhasdiufyahisdlfasdfasdfasdfasdf"
    }),

    watch: {
        $route(val) {
            this.title = val.name;
        }
    },
    created() {

    },
    beforeMount() {},

    mounted() {
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted);
    },

    methods: {
        ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
        onClickBtn() {
            this.setDrawer(!this.$store.state.app.drawer);
        },
        onResponsiveInverted() {
            if (window.innerWidth < 1991) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        changeTabs(ev) {
            store.commit('setTabs', ev);
        }
    }
};
</script>

<style>

    #core-toolbar a {
        text-decoration: none;
    }

</style>
